import React from 'react';
import AdminLayout from './components/adminlayout';
import PrivacyEdit from './components/privacyedit';

const Privacy = () => (
    <AdminLayout>
        <div className='p-6'>
            <div className='bg-white rounded-lg border border-gray-200 p-6'>
                <PrivacyEdit />
            </div>
        </div>
    </AdminLayout>
);
export default Privacy;
